<div class="mui-tabs__navigation" role="tablist">
  <div *ngFor="let tab of tabs; let i = index" class="mui-tabs__navigation-item" routerLinkActive="active">
    <a
      [routerLink]="tab.routerLink"
      class="mui-tabs__navigation-item__link"
      role="tab"
      [attr.aria-posinset]="i + 1"
      [attr.aria-setsize]="tabs.length"
      [attr.aria-controls]="'tab-nav-' + i + '-panel'"
      [attr.aria-label]="tab.label"
      [attr.aria-selected]="selectedTabIndex === i"
      (keydown.enter)="setActiveTab(i)"
      (click)="setActiveTab(i)">
      <i mui-icon *ngIf="tab.icon" [name]="tab.icon" [font]="tab.iconFont" class="mui-tabs__navigation-item__icon"></i>
      <span class="mui-tabs__navigation-item__label">{{ tab.label }}</span>
    </a>
  </div>
</div>
<div class="mui-tabs__tab" [@tab]="prepareRoute(outlet)" role="tabpanel">
  <router-outlet #outlet="outlet"></router-outlet>
</div>
